import React, { Component } from 'react';
import css from './style.css';
import CSSModule from 'react-css-modules';

import TextFeild from '../textFeild';
import Validators from '../../utils/validator';

import DropList from '../dropList';

import { yearData, monthData } from './droplistData';
import nameMap from '../../config/nameMap';
import moment from 'moment';

import { Radio } from 'antd';
const RadioGroup = Radio.Group;

var config = {
        'data': {
            'name' : [ 'notEmpty', {maxLength: 10}, 'isName'],
            'email':['notEmpty','isEmail'],
            'phoneNum':['notEmpty','isPhone'],
            'notification_type': ['notEmpty'],
            'gender': ['notEmpty'],
            'height': ['isHeight']
        }
    }
let val = new Validators(config);	
class StudentData extends Component {
    constructor(props){
        super(props);
        this.state = {
            formData: props.formData || {},
            error: false
        }
        
        this.inputOnChange = (name, value) => {
            this.formValueOnChange(name, value);
        }

        this.radioSelect = (name, e) => {
            this.formValueOnChange(name, e.target.value);
        }

        this.onSelected = (name, value) => {
            this[name] = value.value;
            if( this.year && this.month ) {
                const birth = moment(`${this.year}${this.month}`, "YYYYMM").format();
                this.state.formData.birth = birth;
                this.setState(this.state.formData);
            }
        }

        this.onError = (name, errorMessage) => {
            this.setState({
                error: true
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if( this.props.formData !== nextProps.formData ) {
            this.setState({ formData: nextProps.formData })
        }
    }

    formValueOnChange(name, value) {
        let formData = this.state.formData;
        formData[name] = value;
        this.setState({
            formData: formData,
            error: false
        });
    }
    renderInputBlock(blockArr) {

        return blockArr.map((key, index) => {

            let type = 'text';
            if( key === 'height') type = 'number';

            return (
                <div styleName="block">
                    <p>{ nameMap[key] }</p>
                    <TextFeild 
                        styleName="input" 
                        value={this.state.formData[key]} 
                        type={type}
                        name={key}
                        validator={val}
                        onError={this.onError} 
                        onChange={this.inputOnChange}/>
                </div>
            );
        }) 
    }

    renderRadioBlock(blockArr) {

        return blockArr.map((key, index) => {
            let group;
            if( key === 'gender' ) group = [{label: '男', value: 'male'}, {label: '女', value: 'female'}];
            else group = [{label: '電子郵件信箱', value: 'email'}, {label: '簡訊', value: 'sms'}];

            return (
                <div styleName="block">
                    <p>{ nameMap[key] }</p>
                    <RadioGroup onChange={this.radioSelect.bind(this, key)} value={this.props.formData[key]}>
                        <Radio value={group[0].value} > {group[0].label}</Radio>
                        <Radio value={group[1].value} > {group[1].label}</Radio>
                    </RadioGroup>
                </div>
            );
        }) 
    }

    renderDropList(blockArr) {
        return blockArr.map((key, index) => {
            let group;
            if( key === 'gender' ) group = [{label: '男', value: 'male'}, {label: '女', value: 'female'}];
            else group = [{label: '電子郵件信箱', value: 'email'}, {label: '簡訊', value: 'sms'}];

            return (
                <div styleName="block">
                    <p>{ nameMap[key] }</p>
                    <RadioGroup
                        group={group}
                        name={ key }
                        onSelected={this.radioSelect}
                        styleName="radioGroup"
					/>
                </div>
            );
        }) 
    }

	render() {
        const {gender, notification_type, height, birth } = this.state.formData;
        const year = moment(birth).format('YYYY');
        const month = moment(birth).format('MM');
        return (
            <div className={this.props.className}>
                <div styleName="form">
                    { this.renderInputBlock([
                        'name',
                        'height',
                        'weight'
                    ])}
                    
                    { this.renderRadioBlock([
                        'gender'
                    ]) }

                    
                    <p>生日</p>
                    <DropList
                        defaultIndex={this._getDropIndex(year, yearData)}
                        listContent={yearData}
                        onSelected={this.onSelected.bind(this, 'year')}
                        width={130}/>
                    <DropList 
                        defaultIndex={this._getDropIndex(month, monthData)}
                        listContent={monthData}
                        onSelected={this.onSelected.bind(this, 'month')}
                        width={130}/>
                </div>
            </div>
		);
	}

    _getDropIndex(value, data) {
        for(var i=0; i<data.length; i++) {
            if( parseInt(data[i].value) === parseInt(value) ) return i+1;
        }
        return false;
    }
}

export default CSSModule(StudentData,css);



/** WEBPACK FOOTER **
 ** ./src/component/studentData/index.js
 **/